import '../Styles/NotFoundPage.css';
import { Link } from "react-router-dom";

function NotFoundPage(props) {

    return (
        <div className="NotFoundPage">
            <h2>{props.language === props.uk ? "I'm Sorry" : "Lo siento"}</h2>
            <h3 className='NotFoundPage__link'>{props.language === props.uk ? "The page you are looking for doesn't exist or hasn't been created yet." : "La página que buscas no existe o aún no ha sido creada."}</h3>
            <Link className='NotFoundPage__link'
            to="/">{props.language === props.uk ? "Click me to go back to the main page." : "Haz clic en mí para volver a la página principal."}
            </Link>
        </div>
    )

}

export default NotFoundPage;